export default class AccessibilityContrast {
    constructor() {
        this.storageKeyTheme = 'theme-preference';
        this.theme = {
            value: this.getThemePrefence(),
        };

        this.html = document.querySelector('html');
        this.btnChangeSiteTheme = document.querySelectorAll('.btnActionContrast');

        this.ready();

        this.changeSiteTheme();
    }

    ready() {
        if (this.btnChangeSiteTheme) {
            this.btnChangeSiteTheme.forEach((el) => {
                el.addEventListener('click', () => {
                    if (el.classList.contains('active')) {
                        el.classList.remove('active');
                        this.theme.value = 'default';
                        el.setAttribute('aria-label', 'Alto Contraste - Desativado');
                        el.setAttribute('aria-pressed', 'false');
                    } else {
                        el.classList.add('active');
                        el.setAttribute('aria-label', 'Alto Contraste - Ativado');
                        el.setAttribute('aria-pressed', 'true');
                        this.theme.value = 'dark';
                    }
                    this.setPreference();
                });
            });
        }
    }

    changeSiteTheme() {
        this.html.setAttribute('data-theme', this.theme.value);
        if (
            localStorage.getItem(this.storageKeyTheme) == 'default' ||
            localStorage.getItem(this.storageKeyTheme) == null ||
            localStorage.getItem(this.storageKeyTheme) == undefined
        ) {
            this.html.classList.remove('dark');
            this.btnChangeSiteTheme.forEach((el) => {
                el.classList.remove('active');
                el.setAttribute('aria-pressed', 'false');
                el.setAttribute('aria-label', 'Alto Contraste - Desativado');
            });
        } else {
            this.html.classList.add('dark');
            this.btnChangeSiteTheme.forEach((el) => {
                el.classList.add('active');
                el.setAttribute('aria-pressed', 'true');
                el.setAttribute('aria-label', 'Alto Contraste - Ativado');
            });
        }

        this.btnChangeSiteTheme.forEach((option) => {
            if (this.theme.value == 'dark' && option.classList.contains == 'active') {
                option.checked = true;
            }
        });
    }

    setPreference() {
        localStorage.setItem(this.storageKeyTheme, this.theme.value);
        this.changeSiteTheme();
    }

    getThemePrefence() {
        if (localStorage.getItem(this.storageKeyTheme) && localStorage.getItem(this.storageKeyTheme) != 'undefined') {
            return localStorage.getItem(this.storageKeyTheme);
        } else {
            return 'default';
        }
    }
}

new AccessibilityContrast();
